import * as React from 'react';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const GolfColored = ({ size = 'xsmall' }: IconProps) => {
    return (
        <svg width={IconSizes[size]} height={IconSizes[size]} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
            <g id="Golf" fill="none" fillRule="evenodd">
                <path d="M0 0h24v24H0z" />
                <path d="M9.043 22.357a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9z" fill="#DEDCDA" />
                <path
                    d="M21.132 1.506a1 1 0 1 1 1.739.99l-3.873 6.797a1 1 0 0 1-1.27.42L7.199 5.118a2.998 2.998 0 0 0-2.45.022 2.983 2.983 0 0 0-1.686 3.32l.74 3.64c.16.784.727 1.399 1.456 1.676a5.388 5.388 0 0 1 1.78-1.152h-.637a1 1 0 1 1 0-2h8.722a1 1 0 1 1 0 2h-4.126c.743.295 1.399.75 1.937 1.323h2.434a3.755 3.755 0 0 0 3.275-1.921l2.485-4.451a.999.999 0 1 1 1.746.975l-2.485 4.45a5.757 5.757 0 0 1-5.021 2.947H14.11c.175.53.293 1.085.293 1.672A5.39 5.39 0 0 1 9.018 23a5.39 5.39 0 0 1-5.386-5.383c0-.768.168-1.496.459-2.158a4.318 4.318 0 0 1-2.248-2.962l-.74-3.641A4.97 4.97 0 0 1 3.916 3.32a5 5 0 0 1 4.083-.037l9.707 4.237zM9.018 14.235a3.388 3.388 0 0 0-3.386 3.383A3.389 3.389 0 0 0 9.018 21a3.389 3.389 0 0 0 3.386-3.383 3.388 3.388 0 0 0-3.386-3.383zm1.025-6.545a1 1 0 1 1 0 2H5.55a1 1 0 1 1 0-2z"
                    fill="#0D0E0F"
                />
            </g>
        </svg>
    );
};
